/* eslint-disable @typescript-eslint/no-deprecated -- DEPRECATION: [APPDEV-17834] Re-exports deprecated legacy tooltip symbols. BREAKING-CHANGE: migrate to ChartTooltip before next major. */
export type {
  Variant as _Variant,
  VariantShape as _VariantShape,
  PointShapeType,
} from './core/components/shape/type.js';

export type {
  InteractionMode as _InteractionMode,
  InteractionsOverlayProps as _InteractionsOverlayProps,
  InteractionTriggers as _InteractionTriggers,
  KeyboardOnlyInteractionTriggers as _KeyboardOnlyInteractionTriggers,
  ZoomBehavior as _ZoomBehavior,
} from './core/components/interactions-overlay/types.js';
export { InteractionsOverlay as _InteractionsOverlay } from './core/components/interactions-overlay/InteractionsOverlay.js';
export type { RelativeAbsolutePosition as _RelativeAbsolutePosition } from './core/types/pointer-events.js';
export type { AriaLabel as _AriaLabel } from './core/types/aria-label.js';

export type {
  AnyNumberScale as _AnyNumberScale,
  DateScales as _DateScales,
  NumericScales as _NumericScales,
} from './core/types/scales.js';

export { AnnotationsChartConfig } from './annotations-chart/contexts/AnnotationsChartConfig.context.js';
export { AnnotationsChart } from './annotations-chart/AnnotationsChart.js';
export type { AnnotationsChartConfigProperties } from './annotations-chart/types/annotations-chart-config-props.js';
export type { AnnotationsChartRef } from './annotations-chart/types/annotations-chart-ref.js';
export type { AnnotationsChartProps } from './annotations-chart/types/annotations-chart-props.js';
export type {
  BaseXAxisProps,
  TimeXAxisProps,
  TimestampXAxisProps,
  NumericalXAxisProps,
  XAxisProps,
  XAxisConfig as _XAxisConfig,
  XAxisConfigProps,
} from './annotations-chart/components/axis/types/annotations-x-axis-props.js';
export type {
  AnnotationsActionsPayload,
  AnnotationsActionsHandler,
  BaseAnnotationsChartProps,
} from './core/components/annotations/types/annotations.js';
export type {
  AnnotationsMarkerProps,
  NumericalMarkerProps,
  TimeMarkerProps,
  BaseMarkerProps,
} from './core/components/annotations/types/annotations-marker-props.js';
export type {
  AnnotationsTooltipHandler,
  AnnotationsTooltipItem,
  AnnotationsTooltipProps,
  AnnotationsTooltipConfig,
} from './core/components/annotations/components/tooltip/types/annotations-tooltip-props.js';

export type { AnnotationsTrackProps } from './core/components/annotations/types/annotations-track-props.js';
export { CategoricalBarChart } from './categorical-bar/CategoricalBarChartRoot.js';
export { CategoricalBarChartConfig } from './categorical-bar/hooks/useCategoricalBarChartConfig.js';
export type { CategoricalBarChartThresholdIndicatorProps } from './categorical-bar/slots/ThresholdIndicator.js';
export type {
  CategoricalBarChartCategoryAxisConfiguration,
  CategoricalBarChartCategoryAxisProps,
  CategoricalBarChartConfiguration,
  CategoricalBarChartData,
  CategoricalBarChartLegendConfiguration,
  CategoricalBarChartLegendProps,
  CategoricalBarChartProps,
  CategoricalBarChartRef,
  CategoricalBarChartThresholdConfiguration,
  CategoricalBarChartToolbarConfiguration,
  CategoricalBarChartTooltipConfiguration,
  CategoricalBarChartTooltipProps,
  CategoricalBarChartValueAxisConfiguration,
  CategoricalBarChartValueAxisProps,
  CategoricalChartTooltipVariant,
  // eslint-disable-next-line @typescript-eslint/no-deprecated
  CategoricalUnit,
  GroupMode,
  InternalCategoricalBarChartThresholdConfiguration,
  Layout,
  RequiredCategoricalBarChartConfiguration,
  categoricalChartTooltipVariantOptions,
  groupModeOptions,
  layoutOptions,
} from './categorical-bar/types/categorical-bar-chart.js';
export { AnnotationsAtom as _AnnotationsAtom } from './core/components/annotations/AnnotationsAtom.js';
export { MarkerAtom as _MarkerAtom } from './core/components/annotations/slots/MarkerAtom.js';
export { TrackAtom as _TrackAtom } from './core/components/annotations/slots/TrackAtom.js';

export type { AnnotationsAtomProps as _AnnotationsAtomProps } from './core/components/annotations/AnnotationsAtom.js';
export type { TrackAtomProps as _TrackAtomProps } from './core/components/annotations/types/track.js';
export type {
  MarkerAtomProps as _MarkerAtomProps,
  MarkerInteractionState as _MarkerInteractionState,
  TextOverflowOptions,
} from './core/components/annotations/types/marker.js';

export type {
  TickCategory as _TickCategory,
  TickLabelLayout,
} from './core/components/axes/types.js';
export {
  HORIZONTAL_LABEL_LAYOUT_TYPE,
  VERTICAL_LABEL_LAYOUT_TYPE,
} from './core/components/axes/types.js';
export { ChartGrid as _ChartGrid } from './core/components/chart-grid/ChartGridRoot.js';
export type { ChartGridAreaProps as _ChartGridAreaProps } from './core/components/chart-grid/ChartGridArea.js';
export type { ChartGridProps as _ChartGridProps } from './core/components/chart-grid/ChartGridRoot.js';
export { ChartLayout as _ChartLayout } from './core/components/chart-layout/ChartLayout.js';
export type { ChartLayoutRef as _ChartLayoutRef } from './core/components/chart-layout/types/chart-layout.js';

export type {
  ProviderSlotProp as _ProviderSlotProp,
  LegendProps as _ChartLayoutLegendProps,
  ChartLayoutProps as _ChartLayoutProps,
  ChartLayoutLegendSizes as _ChartLayoutLegendSizes,
  OverrideRatioFunction as _OverrideRatioFunction,
  ChartLayoutDimensions as _ChartLayoutDimensions,
} from './core/components/chart-layout/types/chart-layout.js';
export { getLegendOrientation as _getLegendOrientation } from './core/components/chart-layout/utils/orientation.js';
export { EmptyState as _EmptyState } from './core/components/chart-states/EmptyState.js';
export type { EmptyStateProps as _EmptyStateProps } from './core/components/chart-states/EmptyState.js';
export { ErrorState as _ErrorState } from './core/components/chart-states/ErrorState.js';
export type { ErrorStateProps as _ErrorStateProps } from './core/components/chart-states/ErrorState.js';
export { ChartLegend as _ChartLegend } from './core/components/legend/categorical/ChartLegend.js';
export type { ChartLegendProps as _ChartLegendProps } from './core/components/legend/categorical/ChartLegend.js';
export type { LegendItem as _LegendItem } from './core/components/legend/categorical/types/legend.js';
export { RangeLegend as _RangeLegend } from './core/components/legend/range/RangeLegend.js';
export type {
  RangeItem as _RangeItem,
  RangeLegendProps as _RangeLegendProps,
} from './core/components/legend/range/types/range-legend.js';
export { LegendSizeContext as _LegendSizeContext } from './core/components/legend/shared/context/LegendSizeContext.js';
export { ChartSeriesAction } from './core/components/series-action/ChartSeriesAction.js';
export { useChartActionsMenu as _useChartActionsMenu } from './core/components/series-action/hooks/useChartActionsMenu.js';
export type { ChartSeriesActionProps } from './core/components/series-action/ChartSeriesAction.js';
export type { SeriesActionsTemplate } from './core/types/series-actions-template.js';
export type { SeriesActions } from './core/types/series-actions-template.js';
export { ThresholdBar as _ThresholdBar } from './core/components/threshold-bar/ThresholdBar.js';
export type {
  ThresholdBarProps as _ThresholdBarProps,
  ThresholdMarker as _ThresholdMarker,
  BothBorders as _BothBorders,
  LeftBorder as _LeftBorder,
  RightBorder as _RightBorder,
} from './core/components/threshold-bar/types.js';
export { ThresholdIndicator as _ThresholdIndicator } from './core/components/threshold-bar/indicators/ThresholdIndicator.js';
export type {
  ThresholdIndicatorData as _ThresholdIndicatorData,
  ThresholdIndicatorProps as _ThresholdIndicatorProps,
} from './core/components/threshold-bar/indicators/ThresholdIndicator.js';
export { ChartToolbarRenderer as _ChartToolbarRenderer } from './core/components/toolbar/ChartToolbarRenderer.js';
export type {
  ChartToolbarRendererProps as _ChartToolbarRendererProps,
  IntentsAsyncTemplate as _IntentsAsyncTemplate,
  MenuDisplayMode as _MenuDisplayMode,
  menuDisplayModes as _menuDisplayModes,
  ToolbarHanderRef as _ToolbarHanderRef,
} from './core/components/toolbar/types.js';
export type { InternalChartToolbarConfigured as _InternalChartToolbarConfigured } from './core/types/toolbar.js';
export type { ChartToolbarControlProps as _ChartToolbarControlProps } from './core/components/toolbar/components/Control.js';
// TOOLTIP REGION
export type { Point as _Point } from './core/types/point.js';
/** @deprecated Use `ChartTooltip` instead. Removal: APPDEV-17834 */
export { ChartTooltip as _ChartTooltip } from './core/components/tooltip/ChartTooltip/ChartTooltip.js';
/** @deprecated Use `ChartTooltip` instead. Removal: APPDEV-17834 */
export type { ChartTooltipProps as _ChartTooltipProps } from './core/components/tooltip/ChartTooltip/ChartTooltip.js';
/** @deprecated Use `ChartTooltip` instead. Removal: APPDEV-17834 */
export { ChartTooltipSlots as _ChartTooltipSlots } from './core/components/tooltip/types/ChartTooltip.config.js';
/** @deprecated Use `ChartTooltip` instead. Removal: APPDEV-17834 */
export { ChartTooltipAtoms as _ChartTooltipAtoms } from './core/components/tooltip/types/ChartTooltip.config.js';
/** @deprecated Use `ChartTooltip` instead. Removal: APPDEV-17834 */
export { ChartTooltipTemplate as _ChartTooltipTemplate } from './core/components/tooltip/types/ChartTooltip.config.js';
export type {
  TooltipItem,
  ChartTooltipConfigProps,
} from './core/types/tooltip.js';

/** @deprecated Use `ChartTooltip` instead. Removal: APPDEV-17834 */
export type { PrimaryAtomProps as _PrimaryAtomProps } from './core/components/tooltip-atoms/components/PrimaryAtom.js';
/** @deprecated Use `ChartTooltip` instead. Removal: APPDEV-17834 */
export type { SecondaryAtomProps as _SecondaryAtomProps } from './core/components/tooltip-atoms/components/SecondaryAtom.js';
/** @deprecated Use `ChartTooltip` instead. Removal: APPDEV-17834 */
export type { DurationChipAtomProps as _DurationChipAtomProps } from './core/components/tooltip-atoms/components/DurationChipAtom/DurationChipAtom.js';
/** @deprecated Use `ChartTooltip` instead. Removal: APPDEV-17834 */
export type { BubbleShapeProps as _BubbleShapeProps } from './core/components/shape/BubbleShape/BubbleShape.js';
/** @deprecated Use `ChartTooltip` instead. Removal: APPDEV-17834 */
export type { EmojiShapeProps as _EmojiShapeProps } from './core/components/shape/EmojiShape/EmojiShape.js';
/** @deprecated Use `ChartTooltip` instead. Removal: APPDEV-17834 */
export type { IconShapeProps as _IconShapeProps } from './core/components/shape/IconShape/IconShape.js';
/** @deprecated Use `ChartTooltip` instead. Removal: APPDEV-17834 */
export type { MultiDataPointShapeProps as _MultiDataPointShapeProps } from './core/components/shape/MultiDataPointShape.js';
/** @deprecated Use `ChartTooltip` instead. Removal: APPDEV-17834 */
export type { SingleDataPointShapeProps as _SingleDataPointShapeProps } from './core/components/shape/SingleDataPointShape.js';
/** @deprecated Use `ChartTooltip` instead. Removal: APPDEV-17834 */
export type { ActionSelectionDetails as _ActionSelectionDetails } from './core/components/tooltip/context/ActionSelectionContext.js';
/** @deprecated Use `ChartTooltip` instead. Removal: APPDEV-17834 */
export { GeoItem as _GeoItem } from './core/components/tooltip/ChartTooltip/components/GeoItem.js';
/** @deprecated Use `ChartTooltip` instead. Removal: APPDEV-17834 */
export type { GeoItemProps as _GeoItemProps } from './core/components/tooltip/ChartTooltip/components/GeoItem.js';
/** @deprecated Use `ChartTooltip` instead. Removal: APPDEV-17834 */
export { SeriesItem as _SeriesItem } from './core/components/tooltip/ChartTooltip/components/SeriesItem/SeriesItem.js';
/** @deprecated Use `ChartTooltip` instead. Removal: APPDEV-17834 */
export type { SeriesItemProps as _SeriesItemProps } from './core/components/tooltip/ChartTooltip/components/SeriesItem/SeriesItem.js';
/** @deprecated Use `ChartTooltip` instead. Removal: APPDEV-17834 */
export { TimeFrameHeader as _TimeFrameHeader } from './core/components/tooltip/ChartTooltip/components/TimeFrameHeader/TimeFrameHeader.js';
/** @deprecated Use `ChartTooltip` instead. Removal: APPDEV-17834 */
export type { TimeFrameHeaderProps as _TimeFrameHeaderProps } from './core/components/tooltip/ChartTooltip/components/TimeFrameHeader/TimeFrameHeader.js';
/** @deprecated Use `ChartTooltip` instead. Removal: APPDEV-17834 */
export type { TimestampHeaderProps as _TimestampHeaderProps } from './core/components/tooltip/ChartTooltip/components/TimestampHeader/TimestampHeader.js';
/** @deprecated Use `ChartTooltip` instead. Removal: APPDEV-17834 */
export type { RangeHeaderProps as _RangeHeaderProps } from './core/components/tooltip/ChartTooltip/components/RangeHeader/RangeHeader.js';
/** @deprecated Use `ChartTooltip` instead. Removal: APPDEV-17834 */
export { EventItem as _EventItem } from './core/components/tooltip/ChartTooltip/components/EventItem/EventItem.js';
/** @deprecated Use `ChartTooltip` instead. Removal: APPDEV-17834 */
export type { EvenItemProps as _EventItemProps } from './core/components/tooltip/ChartTooltip/components/EventItem/EventItem.js';
/** @deprecated Use `ChartTooltip` instead. Removal: APPDEV-17834 */
export type { ActionItemProps as _ActionItemProps } from './core/components/tooltip/ChartTooltip/components/ActionItem/ActionItem.js';
/** @deprecated Use `ChartTooltip` instead. Removal: APPDEV-17834 */
export { KeyValue as _KeyValue } from './core/components/tooltip/ChartTooltip/components/KeyValue.js';
/** @deprecated Use `ChartTooltip` instead. Removal: APPDEV-17834 */
export type { KeyValueProps as _KeyValueProps } from './core/components/tooltip/ChartTooltip/components/KeyValue.js';
/** @deprecated Use `ChartTooltip` instead. Removal: APPDEV-17834 */
export { TextHeader as _TextHeader } from './core/components/tooltip/ChartTooltip/components/TextHeader.js';
/** @deprecated Use `ChartTooltip` instead. Removal: APPDEV-17834 */
export type { TextHeaderProps as _TextHeaderProps } from './core/components/tooltip/ChartTooltip/components/TextHeader.js';
/** @deprecated Use `ChartTooltip` instead. Removal: APPDEV-17834 */
export { DurationChip as _DurationChip } from './core/components/tooltip/ChartTooltip/components/DurationChip.js';
/** @deprecated Use `ChartTooltip` instead. Removal: APPDEV-17834 */
export type { DurationChipProps as _DurationChipProps } from './core/components/tooltip/ChartTooltip/components/DurationChip.js';
export { SharedChartInteractions } from './core/components/shared-chart-interactions/SharedChartInteractions.js';

// OVERLAY TOOLTIP REGION
export { OverlayTooltip as _OverlayTooltip } from './core/components/overlay-tooltip/OverlayTooltip.js';
export { ChartTooltip } from './core/components/overlay-tooltip/OverlayTooltip.js';
export { GEO_DEFAULTS as _GEO_DEFAULTS } from './core/components/overlay-tooltip/defaults.js';
export { useDefaultConfig as _useDefaultConfig } from './core/components/overlay-tooltip/hooks/useDefaultConfig.js';
export { useDefaultLabels as _useDefaultLabels } from './core/components/overlay-tooltip/hooks/useDefaultLabels.js';
export type { DefaultConfigByGeoLayer as _DefaultConfigByGeoLayer } from './core/components/overlay-tooltip/types.js';
export {
  OverlayProvider as _OverlayProvider,
  useOverlay as _useOverlayChart,
} from './core/components/overlay-tooltip/contexts/OverlayContext.js';
export {
  TooltipProvider as _OverlayTooltipProvider,
  useTooltip as _useOverlayTooltipStore,
} from './core/components/overlay-tooltip/contexts/TooltipContext.js';
export { useTooltipReducer as _useOverlayTooltipReducer } from './core/components/overlay-tooltip/useTooltipReducer.js';
export { useTooltipData as _useOverlayTooltipData } from './core/components/overlay-tooltip/hooks/useTooltipData.js';
export {
  useTooltipActions as _useOverlayTooltipActions,
  type EventCoords as _EventCoords,
} from './core/components/overlay-tooltip/useTooltipActions.js';
export type {
  OverlayTooltipBaseProps as _OverlayTooltipBaseProps,
  OverlayTooltipUncontrolledProps as _OverlayTooltipUncontrolledProps,
  OverlayTooltipControlledProps as _OverlayTooltipControlledProps,
  TooltipState as _OverlayTooltipState,
  TooltipStore as _OverlayTooltipStoreType,
  OverlayTooltipProps as _OverlayTooltipProps,
  Data as _OverlayTooltipData,
  NoData as _OverlayTooltipNoData,
  HeaderData,
  TooltipValue,
  GeometryTypes as _OverlayTooltipGeometryTypes,
  GeometryTypesEnum as _GeometryTypesEnum,
  SeriesHeaderProps,
  Positions as _OverlayTooltipPositions,
  Overlay as _OverlayTooltipOverlay,
  SeriesName,
  GeoLayerTypes as _OverlayTooltipGeoLayerTypes,
  DefaultConfig as _OverlayTooltipDefaultConfig,
  FormatStrategy as _OverlayTooltipFormatStrategy,
  TooltipAction as _OverlayTooltipAction,
  DefaultConfigByGeometry as _OverlayTooltipDefaultConfigByGeometry,
  Geometry as _OverlayTooltipGeometry,
} from './core/components/overlay-tooltip/types.js';
export type { ActionProps } from './core/components/overlay-tooltip/components/global-actions/Action.js';
export type { ActionsPlaceholderProps } from './core/components/overlay-tooltip/components/global-actions/ActionsPlaceholder.js';
export type {
  HeaderProps as ChartTooltipHeaderProps,
  HeaderDataWithDuration,
  HeaderDataInformation,
} from './core/components/overlay-tooltip/components/header/types/header.js';
export type { FooterProps as ChartTooltipFooterProps } from './core/components/overlay-tooltip/components/Footer.js';
export { useDefaultLabels as _useOverlayTooltipDefaultLabels } from './core/components/overlay-tooltip/hooks/useDefaultLabels.js';
export type { Defaults as _OverlayTooltipDefaults } from './core/components/overlay-tooltip/hooks/useDefaultLabels.js';
export type {
  SeriesItemProps,
  ShapeSeriesItemProps,
  SymbolSeriesItemProps,
  IconSeriesItemProps,
  BaseSeriesItemProps,
  SeriesItemActions,
  TooltipTruncationOptions,
  TruncationModeMultiLine,
  TruncationModeMaxLines,
  IconStyle,
  Series,
} from './core/components/overlay-tooltip/types/series.js';
export type { useTooltipReducer as _OverlayTooltipReducerType } from './core/components/overlay-tooltip/useTooltipReducer.js';

export {
  SIXTY_FPS as _FPS,
  DEFAULT_TRUNCATION_MODE,
  CSS_DOWNLOAD_FILENAME,
} from './core/constants.js';
export { getTabIndexValue as _getTabIndexValue } from './core/utils/a11yToolbarControls.js';
export { getTabIndexKey as _getTabIndexKey } from './core/utils/a11yToolbarControls.js';
export { buildQuantizedRangeItems as _buildQuantizedRangeItems } from './core/utils/build-quantized-range-items.js';
export { buildCategoricalItemsFromScale as _buildCategoricalItemsFromScale } from './core/utils/build-categorical-items-from-scale.js';
export { buildLegendItemsFromRange as _buildLegendItemsFromRange } from './core/utils/build-legend-items-from-range.js';
export { buildQuantizeScaleFromColorPalette as _buildQuantizeScaleFromColorPalette } from './core/utils/build-quantize-scale-from-color-palette.js';
export { buildThresholdScaleFromRanges as _buildThresholdScaleFromRanges } from './core/utils/build-threshold-scale-from-ranges.js';
export { coerceSizeValue as _coerceSizeValue } from './core/utils/coerceSizeValue.js';
export { isCustomColorPalette as _isCustomColorPalette } from './core/types/color-palette.js';
export { useA11yToolbarControls as _useA11yToolbarControls } from './core/hooks/useA11yToolbarControls.js';
export { useA11yToolbarTabIndex as _useA11yToolbarTabIndex } from './core/hooks/useA11yToolbarTabIndex.js';
export type {
  ToolbarInteractionModes as _ToolbarInteractionModes,
  MenuTrigger as _MenuTrigger,
  Collapse as _Collapse,
} from './core/types/toolbar-interaction-modes.js';
export { useThrottledResizeObserver as _useThrottledResizeObserver } from './core/hooks/useThrottledResizeObserver.js';
export type {
  _ResizePayload,
  SizeState as _SizeState,
} from './core/hooks/useThrottledResizeObserver.js';
export { useObserveContainerSize as _useObserveContainerSize } from './core/hooks/useObserveContainerSize.js';

export { getCanvasColor as _getCanvasColor } from './core/components/canvas/utils/canvas-color.js';
export {
  type PointsDisplay,
  pointsDisplayOptions,
} from './core/components/canvas/types/canvas-shape.js';

export { useGraphSize as _useGraphSize } from './core/components/chart-layout/hooks/useGraphSize.js';
export { useChartLayoutOrientation as _useChartLayoutOrientation } from './core/components/chart-layout/hooks/useChartLayoutOrientation.js';
export { useChartLayoutLoading as _useChartLayoutLoading } from './core/components/chart-layout/hooks/useChartLayoutLoading.js';
export { useAutoLegendRefresh as _useAutoLegendRefresh } from './core/components/chart-layout/hooks/useAutoLegendRefresh.js';
export { useGridPlotSize as _useGridPlotSize } from './core/components/chart-grid/hooks/useGridPlotSize.js';
export type { GridPlotContextProps as _GridPlotContextProps } from './core/components/chart-grid/context/GridPlotContext.js';
export { useChartLayoutSize as _useChartLayoutSize } from './core/components/chart-layout/hooks/useChartLayoutSize.js';
export { useLegendSize as _useLegendSize } from './core/components/legend/shared/context/LegendSizeContext.js';
export { getTickFormatterMethod as _getTickFormatterMethod } from './core/utils/get-tick-formatter-method.js';
export type { FormatterWithPrecision as _FormatterWithPrecision } from './core/types/formatter.js';

export {
  sequentialColoringOptions as _sequentialColoringOptions,
  divergingColoringOptions as _divergingColoringOptions,
  themedColoringOptions as _themedColoringOptions,
  automaticColoringOptions as _automaticColoringOptions,
  colorPaletteOptions,
  colorPaletteModeOptions,
} from './core/types/color-palette.js';

export type { EmptyStateSlotProps as EmptyStateProp } from './core/slots/chart-states/EmptyStateSlot.js';
export type { ErrorStateSlotProps as ErrorStateProps } from './core/slots/chart-states/ErrorStateSlot.js';
// eslint-disable-next-line @typescript-eslint/no-deprecated
export { ChartToolbar } from './core/slots/toolbar/ChartToolbar.js';
export type { CompactToolbarProps } from './core/slots/toolbar/CompactToolbar.tsx';
export type { ChartMessage } from './core/types/chart-message.js';
export type { ChartData, ChartDatapoint } from './core/types/chart-data.js';
export type { ChartUnit } from './core/types/chart-unit.js';
export type {
  ColorPalette,
  CustomColorPalette,
  ColorPaletteMode,
  ColorToken,
  AutomaticColorPalette as _AutomaticColorPalette,
  ThemedColorPalette as _ThemedColorPalette,
  ColorPaletteDefinition as _ColorPaletteDefinition,
} from './core/types/color-palette.js';
export type { DateString } from './core/types/dates.js';
export type { Dimensions as _Dimensions } from './core/types/dimensions.js';
export type {
  CategoricalFormatter,
  Formatter,
  TimeFormatter,
} from './core/types/formatter.js';
export type {
  LegendPosition,
  LegendRatio,
  LegendProps,
  ChartLegendOrientation as _ChartLegendOrientation,
  legendPositionOptions,
} from './core/types/legend.js';
export type {
  MaxScaleBoundary,
  MinScaleBoundary,
} from './core/types/min-max-config.js';
export type {
  AxisScaleType,
  ValueRepresentation,
  axisScaleTypeOptions,
  valueRepresentationOptions,
} from './core/types/scales.js';
export type { ColoredRange } from './core/types/colored-range.js';
export type {
  DynamicRangeThreshold,
  DynamicNumericRangeThreshold,
  DynamicThreshold,
  DynamicNumericThreshold,
  StaticRangeThreshold,
  StaticThreshold,
  ThresholdData,
  ThresholdPosition,
  DateThresholdData,
  DateThresholdPosition,
  NumericalThresholdData,
  NumericalThresholdPosition,
  DateThresholdConfig,
  NumericalThresholdConfig,
  BaseThresholdConfig,
} from './core/types/thresholds.js';
export type {
  TickPrimitiveValue,
  TickValueFormatter,
} from './core/types/tick-value.js';
export type {
  ChartToolbarConfig,
  ChartToolbarProps,
  ToolbarPlacement,
  A11yToolbarTabIndex as _A11yToolbarTabIndex,
  InternalChartToolbarConfig as _InternalChartToolbarConfig,
  DraggableToolbarProps,
  BaseToolbarProps,
} from './core/types/toolbar.js';
export type {
  SeriesDisplayMode,
  TooltipVariant,
  seriesDisplayModeOptions,
  tooltipVariantOptions,
} from './core/types/tooltip.js';
export type { WithId } from './core/types/with-id.js';
export {
  HistogramChart,
  HistogramAnnotations,
} from './histogram/HistogramChart.js';
export { HistogramChartConfig } from './histogram/contexts/HistogramChartConfig.context.js';
export type {
  HistogramBin,
  HistogramSeries,
  HistogramTooltipVariant,
  histogramTooltipVariantOptions,
  HistogramZoomDomain,
} from './histogram/types/histogram.js';
export type {
  HistogramChartConfigProperties,
  HistogramChartLegendProps,
  HistogramChartProps,
  HistogramChartToolbarProps,
  HistogramChartTooltipProps,
  HistogramChartXAxisProps,
  HistogramChartYAxisProps,
} from './histogram/types/histogram-props.js';
export type {
  HistogramAnnotationsMarkerProps,
  HistogramAnnotationsProps,
  HistogramAnnotationsTrackProps,
} from './histogram/components/annotations-histogram/types.js';
export type { HistogramToolbarSlotProps } from './histogram/types/toolbar.js';
export type { HistogramChartRef } from './histogram/types/histogram-ref.js';
export type { SelectProps } from './histogram/slots/Select.js';
export type { ZoomSlotProps } from './histogram/slots/Zoom.js';
export type { PanSlotProps } from './histogram/slots/Pan.js';
export type { HistogramThresholdIndicatorProps } from './histogram/slots/ThresholdIndicator.js';
export { HoneycombChart } from './honeycomb/HoneycombChart.js';
export { HoneycombChartConfig } from './honeycomb/context/honeycomb-chart-config.context.js';
export type {
  HoneycombChartRef,
  HoneycombChartProps,
  HoneycombLabelsDisplay,
  HoneycombChartAccessorDataProps,
  HoneycombTileData,
  HoneycombTileShape,
  HoneycombTileBaseData,
  HoneycombTileNumericData,
  HoneycombTileCategoricalData,
  HoneycombCategoricalProps,
  HoneycombChartNumericalProps,
  HoneycombBaseProps,
} from './honeycomb/types/honeycomb.js';
export type {
  HoneycombChartProperties,
  HoneycombChartToolbarConfiguration,
} from './honeycomb/types/honeycomb-config-properties.js';
export type { HoneycombLegendProps } from './honeycomb/slots/HoneycombLegend.js';
export type {
  HoneycombChartTooltipProps,
  HoneycombCustomTooltipConfig,
  HoneycombTooltipPayload,
} from './honeycomb/types/honeycomb-internal.js';
export type { HoneycombToolbarSlotProps } from './honeycomb/types/toolbar.js';
export { MultiMeterBarChart } from './meter-bar/multi-meter-bar/MultiMeterBarChart.js';
export type { MultiMeterBarChartLegendProps } from './meter-bar/multi-meter-bar/slots/Legend.js';
export { MultiMeterBarChartConfig } from './meter-bar/multi-meter-bar/context/MultiMeterBarChartConfigContext.js';
export type {
  MultiMeterBarChartProps,
  MultiMeterBarChartTooltipProps,
  MultiMeterBarSegmentProps,
  MultiMeterBarSegmentBaseProps,
  MultiMeterBarSegmentPropsWithAccessor,
  MultiMeterBarSegmentPropsWithNumericValue,
  MultiMeterBarSegmentData,
  MultiMeterBarChartData,
  MultiMeterBarChartTooltipPayload,
  MultiMeterBarChartTooltipSegmentPayload,
  MultiMeterBarChartActiveSegmentPayload,
} from './meter-bar/multi-meter-bar/types/multi-meter-bar-chart.js';
export type {
  MultiMeterBarChartConsumerConfig,
  MultiMeterBarChartTooltipConsumerConfig,
} from './meter-bar/multi-meter-bar/types/multi-meter-bar-chart-config.js';
export {
  type MultiMeterBarChartTooltipVariant,
  multiMeterBarChartTooltipVariantOptions,
} from './meter-bar/multi-meter-bar/types/multi-meter-bar-chart.js';
export type {
  MeterBarSize,
  MeterBarChartElementRef,
  MultiMeterBarChartElementRef,
} from './meter-bar/shared/types/meter-bars.js';
export { MeterBarChart } from './meter-bar/single-meter-bar/MeterBarChart.js';
export type { MeterBarChartLegendProps } from './meter-bar/shared/types/meter-bar-legend.js';
export { MeterBarChartThresholdLegend as _MeterBarChartThresholdLegend } from './meter-bar/single-meter-bar/components/MeterBarChartThresholdLegend/MeterBarChartThresholdLegend.js';
export { MeterBarChartConfig } from './meter-bar/single-meter-bar/context/MeterBarChartConfigContext.js';
export type {
  MeterBarChartProps,
  MeterBarChartPropsWithAccessor,
  MeterBarChartPropsWithNumericValue,
  MeterBarChartThresholdIndicatorProps,
  MeterBarChartTooltipProps,
  MeterBarSegmentData,
  MeterBarChartBaseProps,
  MeterBarChartData,
  MeterBarChartTooltipPayload,
  MeterBarChartActiveThreshold,
} from './meter-bar/single-meter-bar/types/meter-bar-chart.js';
export type {
  MeterBarChartConsumerConfig,
  MeterBarChartThresholdConsumerConfig,
  MeterBarChartTooltipConsumerConfig,
} from './meter-bar/single-meter-bar/types/meter-bar-chart-config.js';
export type {
  MeterBarToolbarSlotProps,
  MeterBarToolbarConfig,
} from './meter-bar/shared/types/meter-bar-toolbar.js';
export { PieChart } from './pie/PieChart.js';
export { DonutChart } from './pie/DonutChart.js';
export {
  DonutChartConfig,
  PieChartConfig,
} from './pie/context/ChartConfigContext.js';
export type { DonutChartRef, PieChartRef } from './pie/types/pie-chart-ref.js';
export type {
  DonutChartAccessorDataProps,
  DonutChartBaseProps,
  DonutChartData,
  DonutChartLegacyDataProps,
  DonutChartLegendConfig,
  DonutChartProps,
  DonutChartCustomTooltipProps,
  GroupConfig,
  InnerHandler,
  InnerParams,
  LabelTypeOptions,
  LabelsConfig,
  PieChartAccessorDataProps,
  PieChartBaseProps,
  PieChartConfiguration,
  PieChartContextConfig,
  PieChartCustomTooltipConfig,
  PieChartData,
  PieChartLegacyDataProps,
  PieChartLegendConfig,
  PieChartProps,
  PieChartTooltipPayload,
  PieChartCustomTooltipProps,
  SliceData,
  // eslint-disable-next-line @typescript-eslint/no-deprecated
  SliceUnit,
  ThresholdConfig,
  ThresholdType,
  thresholdTypeOptions,
} from './pie/types/pie-chart.config.js';
// eslint-disable-next-line @typescript-eslint/no-deprecated
export type { PieChartSlotProps } from './pie/types/toolbar.js';
export type { PieChartToolbarSlotProps } from './pie/types/toolbar.js';
export type { PieChartToolbarConfig } from './pie/types/toolbar.js';
export { SingleValue } from './single-value/SingleValue.js';
export { SingleValueGrid } from './single-value-grid/SingleValueGrid.js';
export type { SingleValueGridProps } from './single-value-grid/types/single-value-grid.js';
export type { SingleValueGridSparklineProps } from './single-value-grid/slots/Sparkline.js';
export type { SingleValueGridTrendProps } from './single-value-grid/slots/Trend.js';
export type { SingleValueGridValueProps } from './single-value-grid/slots/Value.js';
export type { SingleValueSparklineProps } from './single-value/slots/Sparkline.js';
export type { InverseTrendOptions } from './core/components/single-value-renderer/components/trend/types/inverse-trend-options.js';
export type { TrendDirection } from './core/components/single-value-renderer/components/trend/types/trend-direction.js';
export type { TrendIndicatorColors } from './core/components/single-value-renderer/components/trend/types/trend-indicator-colors.js';
export type { TrendProps } from './core/components/single-value-renderer/components/trend/types/trend-props.js';

export { SingleValueConfig } from './single-value/hooks/use-single-value-config.js';
export type {
  SingleValueConfigProperties,
  SingleValueProps,
  SingleValueSparklineConfig,
} from './single-value/types/single-value.js';
export type { SingleValueRef } from './single-value/types/single-value-ref.js';
export { Sparkline } from './sparkline/Sparkline.js';
export type { TimeseriesChartAnnotationsProps } from './timeseries/slots/annotations/Annotations.js';
export {
  TimeseriesAnnotations,
  TimeseriesChart,
} from './timeseries/TimeseriesChart.js';
export { TimeseriesChartConfig } from './timeseries/context/TimeseriesChartConfig.context.js';
export type { TimeseriesChartLegendProps } from './timeseries/slots/Legend.js';
export type { TimeseriesChartThresholdIndicatorProps } from './timeseries/slots/ThresholdIndicator.js';
export type { TimeseriesChartTooltipProps } from './timeseries/slots/Tooltip.js';
export type { TimeseriesChartXAxisProps } from './timeseries/slots/XAxis.js';
export type {
  TimeseriesChartYAxisProps,
  YAxisPosition,
} from './timeseries/slots/YAxis.js';
export type { TimeseriesAnnotationsMarkerProps } from './timeseries/slots/annotations/Marker.js';
export type { TimeseriesAnnotationsTrackProps } from './timeseries/slots/annotations/Track.js';
/* eslint-disable-next-line @typescript-eslint/no-deprecated */
export { ChartInteractions } from './core/slots/chart-interactions/ChartInteractions.js';
export type { TimeseriesChartAreaProps } from './timeseries/slots/shapes/Area.js';
export type { TimeseriesChartBarProps } from './timeseries/slots/shapes/Bar.js';
export type { TimeseriesChartLineProps } from './timeseries/slots/shapes/Line.js';
export type { TimeseriesSelectProps } from './timeseries/slots/Select.js';
export type { TimeseriesChartToolbarSlotProps } from './timeseries/types/toolbar.js';
export type { TimeseriesZoomSlotProps } from './timeseries/slots/Zoom.js';
export type { TimeseriesPanSlotProps } from './timeseries/slots/Pan.js';
export type {
  ChartInteractionsConfig,
  ZoomChangeHandler,
  ZoomInteractions,
  ZoomRanges,
} from './core/types/interactions.js';
export type {
  ProgrammaticZoomHandlers,
  ChartInteractionModes as _ChartInteractionModes,
  DownloadData as _DownloadData,
  Intent as _Intent,
} from './core/types/zoom.js';
export type { ChartZoomConfig, ZoomChangeType } from './core/types/zoom.js';
export type {
  ChartVariant,
  TimeseriesChartVisualProps,
  TimeseriesZoomDomain,
  chartVariantOptions,
} from './timeseries/types/timeseries.js';
export type {
  TimeseriesBand,
  TimeseriesBandDataPoint,
  TimeseriesChartBandProps,
} from './timeseries/types/timeseries-band.js';
export type { TimeseriesChartConfigProperties } from './timeseries/types/timeseries-config.js';
export type {
  TimeseriesDatapoint,
  SeriesCurve,
} from './core/types/timeseries.js';
export type {
  NumericalGapPolicy,
  NumericalThresholdGapPolicy,
  ThresholdGapPolicy,
  TimeGapPolicy,
  TimeThreshold,
  TimeUnit,
} from './core/types/gap-policy.js';
export type { TimeseriesChartProps } from './timeseries/types/timeseries-props.js';
export type { TimeseriesChartRef } from './timeseries/types/timeseries-ref.js';
export type { TimeseriesChartToolbarConfig } from './timeseries/types/toolbar.js';
export type {
  ColorRuleProps,
  ColorSpecification,
  ComparisonOperators,
  MatchValue,
} from './core/types/color-rule.js';

// CONVERT-TO-TIMESERIES REGION
export {
  convertQueryResultToTimeseries,
  convertToTimeseries,
} from './timeseries/utils/convert-to-timeseries/convert-to-timeseries.js';
export type { TimeseriesWithDimensions } from './timeseries/types/convert-to-timeseries.js';
export { convertToTimeseriesBand } from './timeseries/utils/convert-to-timeseries/convert-to-timeseries-band.js';
export {
  getFieldsArrayForRecordIndex,
  getTypesForRecordIndex,
  convertToFieldEntries,
} from './timeseries/utils/convert-to-timeseries/utils/getFieldsArrayForRecordIndex.js';
export type { FieldEntry } from './timeseries/utils/convert-to-timeseries/utils/getFieldsArrayForRecordIndex.js';
export { checkTimeseriesFormat } from './timeseries/utils/convert-to-timeseries/utils/check-timeseries-format.js';
export { getDimensions } from './timeseries/utils/convert-to-timeseries/utils/get-dimensions.js';
export type { Dimension } from './timeseries/utils/convert-to-timeseries/utils/get-dimensions.js';
export { _getMetadataMetricsUnitForFieldName } from './timeseries/utils/convert-to-timeseries/utils/get-metadata-metrics-unit-for-field-name.js';

// XYChart REGION
export type { XYChartAnnotationsTrackProps } from './xy-chart/slots/Annotations/Track.js';
export type { XYChartAnnotationsConfigProps } from './xy-chart/context/XYChartAnnotationsConfig.context.js';
export type { XYChartAnnotationsProps } from './xy-chart/slots/Annotations/Annotations.js';
export type { XYChartAnnotationsMarkerProps } from './xy-chart/slots/Annotations/Marker.js';
export type { XYChartSelectProps } from './xy-chart/slots/Select.js';
export { XYChart, XYChartAnnotations } from './xy-chart/XYChartRoot.js';
export { XYChartConfig } from './xy-chart/context/XYChartConfig.context.js';
export type {
  XYChartData,
  XYAccessorDataTypes,
  XYChartAxisType,
  XYChartXAxisPosition,
  XYChartYAxisPosition,
  XYChartRectSeriesActionItem,
  XYChartColorPalette,
  RectDatapoint,
  XYChartRef,
  TOP_POSITION,
  BOTTOM_POSITION,
  LEFT_POSITION,
  RIGHT_POSITION,
  BOTH_POSITION,
  LOG_SCALE_TYPE,
  NUMERICAL_SCALE_TYPE,
  TIME_SCALE_TYPE,
  CATEGORICAL_SCALE_TYPE,
  BAR_VARIANT_SINGLE,
  BAR_VARIANT_STACK,
  BAR_VARIANT_GROUP,
  BaseDatapoint,
  DotDatapoint,
  LineDatapoint,
  BarDatapoint,
  AreaDatapoint,
  SeriesCurve as XYChartSeriesCurve,
  BarSeriesVariant,
  XYChartDotSeriesActionItem,
  XYChartLineSeriesActionItem,
  XYChartBarSeriesActionItem,
  XYChartAreaSeriesActionItem,
  XYChartThresholdLineBase,
  XYChartThresholdRangeBase,
  XYChartThresholdDynamicData,
  XYChartThresholdDataLineDynamic,
  XYChartThresholdDataLineStatic,
  XYChartThresholdDataRangeStatic,
  XYChartThresholdValue,
  XYChartThresholdStaticData,
  XYChartThresholdDataRangeDynamic,
  XYChartSelectedSeries,
  XYChartSelectedDomains,
  AxisFormatter,
  NumericalFormatter,
  XYChartTooltipPayload,
  DotTooltipPayload,
  LineTooltipPayload,
  RectTooltipPayload,
  BaseTooltipPayload,
  BarTooltipPayload,
  XYChartSeriesActionInfo,
  XYChartBarSeries,
  XYChartDotSeries,
  XYChartLineSeries,
  XYChartRectSeries,
  XYChartAreaSeries,
  AreaTooltipPayload,
  XYChartTooltipDatapoint,
} from './xy-chart/types/xy-chart.js';

export type {
  XYChartProps,
  XYChartRectSeriesProps,
  // eslint-disable-next-line @typescript-eslint/no-deprecated
  ColorSelectionProp,
  ShapeColorSelectionProp,
  XYShapeColorProp,
  XYShapeColorPaletteProp,
  XYChartAxisProps,
  XYChartAxisBaseProps,
  XYChartLogAxisProps,
  XYChartNumericalAxisProps,
  XYChartCategoricalAxisProps,
  XYChartTimeAxisProps,
  XYChartXAxisProps,
  XYChartYAxisProps,
  XYChartChartLegendProps,
  XYChartConfigProperties,
  XYChartBarSeriesProps,
  XYChartAreaSeriesProps,
  BarSeriesProps,
  StackBarSeriesProps,
  SingleBarSeriesProps,
  BaseBarSeriesProps,
  StackBarVerticalProps,
  StackBarHorizontalProps,
  BarSeriesVariantMap,
  GroupBarSeriesProps,
  GroupBarVerticalProps,
  GroupBarHorizontalProps,
  XYChartSeriesBaseProps,
  XYChartDotSeriesProps,
  XYChartLineSeriesProps,
  XYChartToolbarConfigProps,
  // eslint-disable-next-line @typescript-eslint/no-deprecated
  XYChartToolbarProps,
  XYChartToolbarSlotProps,
  XYChartThresholdIndicatorProps,
  XYChartThresholdDynamicProps,
  XYChartThresholdStaticProps,
  XYChartSelectConfig,
  // eslint-disable-next-line @typescript-eslint/no-deprecated
  XYChartCustomTooltipProps,
  XYChartTooltipProps,
  _XYChartTooltipVariant,
} from './xy-chart/types/xy-chart-props.js';

export type { XYChartTooltipBodyProps as _XYChartTooltipBodyProps } from './xy-chart/components/tooltip/XYChartTooltipBody/XYChartTooltipBody.js';
export { XYChartTooltipBody as _XYChartTooltipBody } from './xy-chart/components/tooltip/XYChartTooltipBody/XYChartTooltipBody.js';

// TopList REGION
export { TopList } from './top-list/TopList.js';
export type { TopListProps } from './top-list/TopList.js';

// XYChart Adoption REGION
export type { _XYChartAdoptionProps } from './xy-chart-adoption/shared/types/props.js';
export type { _XYChartLegacyProps } from './xy-chart-adoption/shared/types/legacy-props.js';

// GANTT CHART REGION
export type {
  GanttChartConfig,
  GanttChartFormatter,
  GanttChartFormatterCurrencyOptions,
  GanttSegmentData,
  GanttAnnotationsHeaderConfig,
  GanttAnnotationsMarkerProps,
  GanttAnnotationsTrackConfig,
} from './gantt-chart/types/gantt-chart.js';

// TreeMap Region
export { TreeMap } from './tree-map/TreeMap.js';
export type {
  TreeMapProps,
  TreeMapBaseProps,
  TreeMapHierarchicalProps,
  TreeMapFlatProps,
  TreeMapData,
  TreeMapLeafNode,
  TreeMapRootNode,
  TreeMapClusterNode,
  LabelsDisplay,
  NameAccessor,
  TreeMapElementRef,
} from './tree-map/types/treemap.js';
export type {
  TreeMapContextConfig,
  TreemapChartLegendConfig,
  TreeMapChartToolbarConfig,
  TreeMapCustomTooltipConfig,
  TreeMapCustomTooltipProps,
  TreeMapTooltipPayload,
} from './tree-map/types/treemap-chart.config.js';
export { TreeMapConfig } from './tree-map/context/TreeMapConfigContext.js';

// CORE REGION
export { useMousePosition as _useMousePosition } from './core/hooks/useMousePosition.js';
// eslint-disable-next-line @typescript-eslint/no-deprecated
export type { Timeseries, TimeseriesUnit } from './core/types/timeseries.js';
export type { IndicatorsDisplay } from './core/components/annotations/components/indicators/types.js';
export type { MinMax as _MinMax } from './core/types/min-max.js';
// eslint-disable-next-line @typescript-eslint/no-deprecated
export { truncateText as _truncateText } from './core/utils/text-truncation.js';

// CORE SPARKLINE REGION
export type {
  SparklineProps,
  SparklinLabelsAlignment,
  SparklineVariant,
  SparklineGapPolicy,
} from './core/components/sparkline-display/types/sparkline-props.js';
export type {
  // eslint-disable-next-line @typescript-eslint/no-deprecated
  SparklineThresholdProps,
  SparklineThresholdIndicatorProps,
} from './core/components/sparkline-display/types/sparkline-thresholds-props.js';
export type {
  SparklineXAxisProps,
  SparklineXAxisInternalProps as _SparklineXAxisInternalProps,
} from './core/components/sparkline-display/types/sparkline-x-axis-props.js';
export type { SparklineYAxisProps } from './core/components/sparkline-display/types/sparkline-y-axis-props.js';

// CORE SINGLE VALUE REGION
export type {
  // eslint-disable-next-line @typescript-eslint/no-deprecated
  SingleValueUnit,
  SingleValueAlignment,
  SingleValueBaseProps,
} from './core/components/single-value-renderer/types/single-value-base-props.js';
export type {
  SingleValueToolbarSlotProps,
  SingleValueToolbarInternalProps as _SingleValueToolbarInternalProps,
} from './single-value/types/single-value-toolbar.js';
export type { SingleValueToolbarConfig } from './core/components/single-value-renderer/components/SingleValueToolbar.js';
// GAUGE CHART REGION
export { GaugeChart } from './gauge/GaugeChart.js';
export type { GaugeChartThresholdIndicatorProps } from './gauge/slots/ThresholdIndicator.js';
export { GaugeChartConfig } from './gauge/contexts/GaugeChartConfigContext.js';
export type {
  GaugeChartBaseProps,
  GaugeChartProps,
  GaugeChartPropsWithAccessor,
  GaugeChartPropsWithNumericValue,
  GaugeChartRef,
  GaugeChartData,
} from './gauge/types/gauge-chart.js';
export type { GaugeChartConsumerConfig } from './gauge/types/gauge-chart-config.js';
export type {
  GaugeChartTooltipProps,
  GaugeChartTooltipHandler,
  GaugeChartTooltipItem,
} from './gauge/slots/Tooltip.js';
export type {
  TooltipEmojiProps,
  TooltipIndicatorProps,
  TooltipTextProps,
  TooltipDurationProps,
  TooltipValueProps,
  TooltipItemProps,
  TooltipBodyProps,
  TooltipFooterProps,
  VirtualEstimatedSize,
  TooltipHeaderProps,
} from './core/components/tooltip/types/tooltip.js';
/** @deprecated Use `ChartTooltip` instead. Removal: APPDEV-17834 */
export type { ChartTooltipTemplateType as _ChartTooltipTemplateType } from './core/components/tooltip/types/ChartTooltip.config.js';
/** @deprecated Use `ChartTooltip` instead. Removal: APPDEV-17834 */
export type { ChartTooltipAtomsType as _ChartTooltipAtomsType } from './core/components/tooltip/types/ChartTooltip.config.js';
/** @deprecated Use `ChartTooltip` instead. Removal: APPDEV-17834 */
export type { ChartTooltipSlotsType as _ChartTooltipSlotsType } from './core/components/tooltip/types/ChartTooltip.config.js';
export { colorPaletteMap as _colorPaletteMap } from './core/types/color-palettes-definitions.js';
export { automaticColoringMap as _automaticColoringMap } from './core/types/color-palettes-definitions.js';
